import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider,
  Grid
} from '@material-ui/core';
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { addBankTopup } from 'src/store/actions/TopupActions';

function BankTopup({ open, handleClose }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const profile = useSelector(state => state.Auth.profile);

  const handleBankTopup = async values => {
    setLoading(true);
    const response = await dispatch(addBankTopup(values));
    if (response === -1) {
      setLoading(false);
      // handleClose();
    } else {
      setLoading(false);
      handleClose();
      window.open(`https://lasrra-pay.touchandpay.me/${response}`, '_blank');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        <Typography color="textPrimary" variant="h2">
          Add Bank Topup
        </Typography>
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={{
          amount: ''
        }}
        validationSchema={Yup.object().shape({
          amount: Yup.string()
            .trim()
            .max(255)
            .required('Amount is required')
        })}
        onSubmit={values => {
          handleBankTopup(values);
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    error={Boolean(touched.amount && errors.amount)}
                    fullWidth
                    helperText={touched.amount && errors.amount}
                    label="Amount"
                    margin="dense"
                    name="amount"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="number"
                    value={values.amount}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                {loading && <CircularProgress size="1.5rem" />}
                Submit
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}

export default BankTopup;
